import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from 'src/app/core/services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  private innerNav = signal<any>([]);
  private profileUpdate = signal<any>(0);

  private userData = signal<any>({});

  projectsMenu:any[]=[
    {displayName:'Project Overview',route:'/customer/projects/overview',permission:"Projects"},
    {displayName:'BOM',route:'/customer/projects/bom',permission:"BOM"},
    {displayName:'Inventory',route:'/customer/projects/inventory',permission:"Inventory"},
    {displayName:'Production',route:'/customer/projects/production',permission:"Production"},
    {displayName:'Escalations',route:'/customer/projects/escalations',permission:"Escalations"},
    {displayName:'Risks',route:'/customer/projects/risk',permission:"Risks"},
    {displayName:'Invoice',route:'/customer/projects/invoice',permission:"Invoice"},
    {displayName:'Shipping',route:'/customer/projects/shipping',permission:"Shipping"},
    {displayName:'Assets',route:'/customer/projects/assets',permission:"Assets"},
    {displayName:'File Storage',route:'/customer/projects/file-storage',permission:"File Storage"},
    {displayName:'Change Requests',route:'/customer/projects/change-request',permission:"Change Requests"},
    {displayName:'Warranty',route:'/customer/projects/warranty',permission:"Warranty"},
    // {displayName:'Tasks',route:'',permission:""},
    // {displayName:'Payments',route:'',permission:""},
    {displayName:'Feedback',route:'/customer/projects/feedback',permission:"Feedback"},
    // {displayName:'Feedback',route:'/customer/projects/feedback',permission:"Projects"},
    // {displayName:'Approvals',route:'',permission:""},
    // {displayName:'Schedule',route:'',permission:""},
    // {displayName:'Timeline',route:'',permission:""}
  ]

  constructor(
    private router: Router,
    private permission: PermissionService,
    private http: HttpClient
  ) { }

  updateInnerNav(value: any) {
    this.innerNav.set(value);
  }

  getInnerNav() {
    return this.innerNav;
  }

  updateLoginUserData(value: any) {
    this.userData.set(value);
  }

  getLoginUserData() {
    return this.userData;
  }

  updateProfileUpdate(value: any) {
    this.profileUpdate.set(value);
  }

  getProfileUpdate() {
    return this.profileUpdate;
  }


  SetInnerNav(route: any) {
    if (route.includes('/customer/projects/')) {
      const tempItems = this.projectsMenu.map((element) => {
        if (this.permission.checkPermission(element.permission)) {
          return element;
        }
      })
      if (tempItems) {
        this.updateInnerNav(tempItems);
      }
    } else {
      this.updateInnerNav([]);
    }
  }
}